import { render, staticRenderFns } from "./MenuInsightEpos.vue?vue&type=template&id=386e7bba&"
import script from "./MenuInsightEpos.vue?vue&type=script&lang=js&"
export * from "./MenuInsightEpos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports